import { Button, OpenInNewIcon, Stack, Typography } from '@all-manager/design-system-v2';

type Props = {
  title: string;
}

export default function FormSectionTitle(props: Props) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
      <Typography variant="h3">{props.title}</Typography>
      <Button
        variant="text"
        size="small"
        endIcon={<OpenInNewIcon fontSize="small" />}
        href={import.meta.env.VITE_FILE_STORAGE_LINK}
        target="_blank"
        rel="noopener noreferrer"
      >
        Ouvrir le Drive
      </Button>
    </Stack>
  );
}
